import {
    MERCHANT_BALANCE_LIST_INITIATED,
    MERCHANT_BALANCE_INITIATED,
    MERCHANT_BALANCE_LOADED,
    MERCHANT_BALANCE_FAILED,
    MERCHANT_BALANCE_LIST_LOADED,
    MERCHANT_MBH_BALANCE_LIST_INITIATED,
    MERCHANT_MBH_BALANCE_LIST_LOADED,
    MERCHANT_BALANCE_COUNT_INITIATED,
    MERCHANT_BALANCE_COUNT_LOADED,
    MERCHANT_BALANCE_COUNT_FAILED,
    MERCHANT_WALLET_BALANCE_LOADED,
    MERCHANT_WALLET_BALANCE_INITATED,
    MERCHANT_WALLET_BALANCE_FAILED,
    MERCHANT_ESCROW_BALANCE_COUNT_INITIATED,
    MERCHANT_ESCROW_BALANCE_COUNT_LOADED,
    MERCHANT_ESCROW_BALANCE_COUNT_FAILED,
  } from "../actions/MerchantBalanceAction";
  
  const initialState = {
    listdata: [],
    data: [],
    walletBalance : {},
    MBHBalanceHistory : [],
    escrowBalance : {
      NetBalance : "0.00",
      AcocuntTitle : "",
      AccountStatus : "",
    },
    balancetCount : {
        initiated_count: "0",
        initiated_amount: "0",
        initiated_charges: "0",
        initiated_tax: "0",
      
        success_count: "0",
        success_amount: "0",
        success_charges: "0",
        success_tax: "0",

        failure_count: "0",
        failure_amount: "0",
        failure_charges: "0",
        failure_tax: "0",

        inprogress_count: "0",
        inprogress_amount: "0",
        inprogress_charges: "0",
        inprogress_tax: "0"
      
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const MerchantBalanceAction = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_BALANCE_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case MERCHANT_BALANCE_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case MERCHANT_MBH_BALANCE_LIST_INITIATED:
        return {
          ...state,
          MBHBalanceHistory : [],
          loading: true,
          error: null,
        };
      case MERCHANT_MBH_BALANCE_LIST_LOADED:
        console.log('MERCHANT_MBH_BALANCE_LIST_LOADED', action.payload.data)
        return {
          ...state,
          loading: false,
          MBHBalanceHistory: action.payload.data,
        };
      case MERCHANT_BALANCE_INITIATED:
        return { ...state, loading: true, error: null};
      case MERCHANT_BALANCE_LOADED:
        const updatedObj = Object.fromEntries(
            Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
        );
        return { ...state, loading: false, data: updatedObj };
      case MERCHANT_BALANCE_COUNT_INITIATED:
          return { ...state};
      case MERCHANT_BALANCE_COUNT_LOADED:
          return { ...state, balancetCount: action.payload };
      case MERCHANT_BALANCE_COUNT_FAILED:
         return { ...state, loading: false, error: action.payload };
      case MERCHANT_WALLET_BALANCE_INITATED:
        return { ...state};
      case MERCHANT_WALLET_BALANCE_LOADED:
          return { ...state, walletBalance: action.payload };
      case MERCHANT_WALLET_BALANCE_FAILED:
          return { ...state };
      case MERCHANT_ESCROW_BALANCE_COUNT_INITIATED:
        return { ...state};
      case MERCHANT_ESCROW_BALANCE_COUNT_LOADED:
          return { ...state, escrowBalance: action.payload };
      case MERCHANT_ESCROW_BALANCE_COUNT_FAILED:
          return { ...state };
      case MERCHANT_BALANCE_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantBalanceAction;